import React from "react";
import { TileLayer } from "react-leaflet";

const MapTileLayer = ({ mapLayer, minZoom }) => {
  if (!mapLayer) return null;
  if (mapLayer.id === "railwayMap") {
    return (
      <>
        <TileLayer
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap contributors</a>'
          maxZoom={mapLayer.maxZoom}
          maxNativeZoom={mapLayer.maxZoom}
          minZoom={minZoom}
        />
        <TileLayer
          url="https://tiles.openrailwaymap.org/standard/{z}/{x}/{y}.png"
          attribution='<a href="http://www.openrailwaymap.org/">OpenRailwayMap</a>'
          opacity={0.8}
          maxZoom={mapLayer.maxZoom}
          maxNativeZoom={mapLayer.maxZoom}
          minZoom={minZoom}
        />
      </>
    );
  }

  return (
    <TileLayer
      {...mapLayer}
      minZoom={minZoom}
      maxNativeZoom={
        mapLayer.maxZoom > 21 ? mapLayer.maxZoom - 1 : mapLayer.maxZoom
      }
    />
  );
};

export default MapTileLayer;
